import src from "IMAGE";
export default { src, width: 449, height: 196, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42m3LoQrAIBRG4fuvLcwN3C4yEESbgsUgWOwm3/9ptOuBLx4iADu/T1m6EAmneBaXfHVpXcVSaWneuFkdbCzExwPVhgTSW8DbtwAAAABJRU5ErkJggg=="};
